import { FormikProvider, useFormik } from 'formik';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ScrollToTop from '../../../../components/ScrollToTop';
import HeaderComponent from '../../../../components/header/Header.component';
import GenericHeader from '../../../../components/moduleCommonFormik/GenericHeader';
import SideCard from '../../../../components/moduleCommonFormik/SideCardGenericComponent';
import StatusAlertPopup from '../../../../components/moduleCommonFormik/StatusAlertPopup';
import Loading from '../../../../components/portalComponents/Loading.component';
import { POST, POST2, devUrl, endpoints, getProgressBarData, redirectToRestrictedPage, requestInfo } from '../../../../services/modulesServices/userManagement.api';
import { EMPLOYEE_AUTHORIZED, KEY_ID, KYC_ESIGN_FLAG, TENANT_ID, WALLET_REQUEST_MESSAGE_MAKE_PAYMENT_KEY } from '../../../../utils/constants';
import { ALLOTMENT_FORM_VALIDATION, APPLICANT_RES_LIST_VALIDATION_II, OWNERSHIP_VALIDATION, PROPOSED_ACTIVITY_VALIDATION } from '../../../../utils/formikValidation/FormikValidation';
import { decode, encode, getFirstErrorKey, getNavigateTo } from '../../../../utils/utils';
import { dropdownDataOptions, getFormatedOwnershipDetails } from '../../Migration/Migration.controller';
import PlotDetails from '../../Migration/pages/PlotDetails';
import { IdocumentTemplate, RazorpayOptions } from '../../UserManagement/types';
import {
    autoPopulatePlotDetails,
    entityDocumentData,
    fetchFeeData,
    fetchGatewayData,
    getNextActions,
    getOptions,
    getQueryParams,
    loadRazorpay,
    paymentCheck,
    postToPaymentGateway,
    revertApplicantSubmitPayload,
    setApplicantResponse,
    strToNum
} from '../EstateManagement.controller';
import { APPLICANT_DETAILS_I, APPLICANT_DETAILS_II, DECLARATION_DETAILS, ENTERPRISE_DETAILS, PROJECT_DETAILS, PROMOTER_DETAILS, paymentColumns, paymentOptions, stepsDetails } from './Allotment.const';
import { allotmentPayload, getEnterpriseData, getEntityData, setEnterpriseDocData, setEntityDocData, getFormatedNICDetails, getInitPlotData } from './Allotment.controller';
import ApplicantDetails from './ApplicantDetails';
import Declaration from './Declaration';
import EnterpriseDetails from './EnterpriseDetails';
import PaymentDetails from './PaymentDetails';
import { cross, check } from '../../../../utils/Logo';
import GenericButtons from '../../../../components/UI components/Buttons/GenericButtons';
import { TemplateCard } from '../TemplatesCard';
import { toast } from 'react-toastify';
import GenericFooterComponent from '../../../../components/moduleCommonFormik/GenericFooter.component';
import PaymentSubmissionStatus from '../../../technicalFlowScreen/technicalClearanceForm/TechnicalClearencePayment/PaymentSubmissionStatus';
import ProgressBar from '../../../../components/moduleCommonFormik/ProgressBar';
import axios from 'axios';
import { handleUpdates } from '../../UserManagement/UserMangement.controller';
import GenericPopupModal from '../../../../components/moduleCommonFormik/GenericModalPopup.component';
import { EsignModal } from '../../../commonPages/EsignModal';
import { TDSSection } from '../Payment/TDSSection';
import { AdditionalDetails } from './AdditionalDetails';
export interface DropdownData {
    plotNo: string[];
    phase: string[];
    plotType: string[];
    estateName: string[];
}

export default function CreateAllotment(props: any) {
    const location: any = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const searchParams: any = new URLSearchParams(location.search);
    const [searchParamsList] = useSearchParams();
    let reVisit = useRef(searchParams.get('reVisit') === 'true');

    const ipb = decode(searchParams.get('ipb'));
    const auction = decode(searchParams.get('auction'));
    const applicationNumber = decode(searchParams.get('applicationNumber')) || decode(searchParams.get('applicationNo'));
    const signedFileStoreId = decode(searchParams.get('signedFileStoreId'));
    const esignError = decodeURIComponent(searchParams.get('error') || '');

    const [advertisementNumber, setAdvertisementNumber] = useState<any>('');
    const [plotId, setPlotId] = useState<any>('');
    const [activeIndex, setActiveIndex] = useState<number>(1);
    const [visitedIndex, setVisitedIndex] = useState<number>(1);
    const [steps, setSteps] = useState<any>(stepsDetails);
    const [formType, setFormType] = useState<any>('IDC');
    const [documents, setDocuments] = useState<any>([]);
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [documentTemplate, setDocumentTemplate] = useState<any>([]);
    const [filesSelection, setFilesSelection] = useState<any>([]);
    const [isChecked, setIsChecked] = useState([false, false, false]);
    const [addButton, setAddButton] = useState(false);
    const [showDownloadBox, setShowDownloadBox] = useState(false);
    const [ownershipDetails, setOwnershipDetails] = useState<any>([]);
    const [calculated, setCalculated] = useState<boolean>(false);
    const [dropdownData, setDropdownData] = useState<any>(null);
    const [dropdownDataPlot, setDropdownDataPlot] = useState<DropdownData>({
        plotNo: [],
        phase: [],
        plotType: [],
        estateName: []
    });
    const [searchApplicationResponse, setSearchApplicationResponse] = useState<any>({});
    const [applicationNo, setApplicationNo] = useState<any>('');
    const [applicationType, setApplicationType] = useState<any>('');
    const [allotmentDate, setAllotmentDate] = useState<any>(null);
    const [estateResponse, setEstateResponse] = useState<any>({});
    const [modalDetails, setModalDetails] = useState<any>({});
    const [controllingOwnershipResponse, setControllingOwnershipResponse] = useState<any>([]);
    const [nicDetails, setNicDetails] = useState<any>([]);
    const [paymentData, setPaymentData] = useState<any>([]);
    const [gatewayData, setGatewayData] = useState<any>([]);
    const [selectedGateway, setSelectedGateway] = useState<any>(null);
    const [isPaid, setIsPaid] = useState<any>(false);
    const [isApplicantRole, setIsApplicantRole] = useState<any>(true);
    const [paymentTried, setPaymentTried] = useState<any>(false);
    const [totalPaidAmount, setTotalPaidAmount] = useState<any>(0);
    const [transactionDetails, setTransactionDetails] = useState<any>({});
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [paymentIsLoading, setPaymentIsLoading] = useState<boolean>(false);
    const [eSignedDocumentData, setESignedDocumentData] = useState<any>(null);
    const [showPopUp, setShowPopUp] = useState(false);
    const [showOwnershipModal, setShowOwnershipModal] = useState(false);
    const [nextValidAction, setNextValidAction] = useState<any>(null);
    const [hasValidAction, setHasValidAction] = useState<boolean>(true);
    const [progressBarDetails, setProgressBarDetails] = useState<any>(null);
    const [applicationDetailsII, setApplicationDetailsII] = useState<any>(APPLICANT_DETAILS_II);
    const [esignModal, setEsignModal] = useState<boolean>(false);
    const [fileStoreId, setFileStoreId] = useState<any>(null);
    const [bankDetails, setBankDetails] = useState<boolean>(false);
    const [deductions, setDeductions] = useState<any>({ TDSAmount: 0, GST_TDSAmount: 0, TDSChecked: false, GST_TDSChecked: false });
    const [finalPayableAmount, setFinalPayableAmount] = useState<any>(0);

    const queryParams = getQueryParams(searchParamsList);
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    let userType = user?.type;

    const formik = useFormik<any>({
        initialValues: {
            isUpdatable: true,
            specialProject: false,
            confirmation: false,
            applicantGst: false,
            udhyam: false,
            isStartup: false,
            womenEntrepreneur: false,
            localPerson: false,
            priorExperience: false,
            copyOnCheck: [],
            enterpriseCategory: '',
            esignOption: 'DSC'
        },
        onSubmit: value => {},
        validationSchema: !showOwnershipModal && !showPopUp ? ALLOTMENT_FORM_VALIDATION[`page${activeIndex}`] : showPopUp ? PROPOSED_ACTIVITY_VALIDATION : OWNERSHIP_VALIDATION
    });

    const { values, setValues, setTouched, setFieldValue, setFieldTouched, errors, resetForm } = formik;

    const applicantDetailsI = APPLICANT_DETAILS_I.map((val: any) => ({
        ...val,
        formData: val.formData?.map((field: any) => ({ ...field, isDisabled: true }))
    }));

    console.log();

    useEffect(() => {
        const checkRoles = (roles: any, roleNames: any) => {
            if (applicationNumber && !values.isUpdatable) {
                return true;
            }

            for (let i = 0; i < roles.length; i++) {
                if (roleNames.includes(roles[i].code)) {
                    return false;
                }
            }
            return true;
        };

        (async () => {
            try {
                setIsLoading(true);

                let formType = 'IDC';

                if (queryParams?.['auction'] === 'true') {
                    setAdvertisementNumber('');
                    setPlotId('');
                    setSteps(stepsDetails);
                    formType = 'AUCTION';
                    setFormType('AUCTION');
                } else if (queryParams?.['ipb'] === 'true') {
                    setAdvertisementNumber('');
                    setPlotId(values.plotId);
                    setSteps(stepsDetails);
                    formType = 'IPB';
                    setFormType('IPB');
                } else {
                    setAdvertisementNumber(location?.state?.advertisementNumber || '');
                    setPlotId(location?.state?.plotId || '');
                    setSteps(stepsDetails);
                    formType = 'IDC';
                    setFormType('IDC');
                }

                if (formType === 'IDC') queryParams?.['advertisementNumber'] && setAdvertisementNumber(queryParams?.['advertisementNumber'] || '');
                queryParams?.['plotId'] && setPlotId(queryParams?.['plotId'] || '');
                if (queryParams?.['activeIndex']) {
                    setActiveIndex(+queryParams?.['activeIndex']);
                    if (visitedIndex < +queryParams?.['activeIndex']) setVisitedIndex(+queryParams?.['activeIndex']);
                }

                if (queryParams?.['applicationNo'] || queryParams?.['applicationNumber']) {
                    setApplicationNo(queryParams?.['applicationNo'] || queryParams?.['applicationNumber'] || '');
                }

                if (userType !== 'ENTERPRISE') {
                    window.location.href = '/goa-idc/access-restricted';
                }

                if (applicationNumber) {
                    await redirectToRestrictedPage(applicationNumber);
                }

                const dropdownlist: any = await dropdownDataOptions();
                const roles = JSON.parse(localStorage.getItem('user') || '{}').roles;
                const { projectType, ...rest } = dropdownlist;
                const projectTypeFiltered = roles?.every((val: any) => val.code !== 'LESSEE') ? projectType?.filter((item: any) => item.code !== 'EXPANSION') : projectType;

                if (ipb) {
                    setDropdownData({ ...rest, projectType: projectTypeFiltered });
                } else {
                    const dropdownDataFiltered = { ...rest, pollutionCategory: dropdownlist?.pollutionCategory?.filter((item: any) => item.isOnlyForSpecialProject === false) };
                    setDropdownData({ ...dropdownDataFiltered, projectType: projectTypeFiltered });
                }
                const applicantData = await setApplicantData({ ...rest, projectType: projectTypeFiltered });
                if (!applicationNumber) {
                    setValues((prevVal: any) => ({ ...prevVal, ...applicantData }));
                }

                const { data } = await POST(`/idc-estate-service/plot/_metadata-search?plotStatus=VACANT${ipb || auction ? '&isEligibleForApplication=true' : ''}`, { RequestInfo: requestInfo() });

                setDropdownDataPlot({
                    plotNo: [],
                    phase: [],
                    plotType: [],
                    estateName: data.estateNames || []
                });

                applicationNumber && dropdownlist && (await fetchApplicationData(applicationNumber, dropdownlist, applicantData));
                applicationNumber && setApplicationNo(applicationNumber);
                setApplicationType('ALLOTMENT');

                loadRazorpay();

                let params = { ...queryParams };
                setPaymentTried(true);
                await getTransactionUpdate(params);

                if (!!applicationNumber)
                    getProgressBarData(applicationNumber)
                        .then(res => setProgressBarDetails(res.data))
                        .catch(e => console.log(e));

                setIsLoading(false);
            } catch (e: any) {
                setIsLoading(false);
                let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
                setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            }
        })();

        const isEnterprise = checkRoles(user?.roles || [], ['ALLOTTEE', 'TRANSFEREE', 'TRANSFEROR', 'LESSEE']);
        setIsApplicantRole(isEnterprise);

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [location.search]);

    useEffect(() => {
        (async () => {
            try {
                if (plotId && activeIndex === 5) {
                    const payCheck = await paymentCheck('PROCESSING_FEE,SECURITY_DEPOSIT', plotId, queryParams.applicationId || values?.applicationId);
                    setIsPaid(payCheck?.isPaid);
                    setPaymentTried(payCheck?.paymentTried);
                    setPaymentData(payCheck?.paymentData);
                    setTotalPaidAmount(payCheck?.totalPaidAmount);
                    setTransactionDetails(payCheck?.transactionDetails);

                    const gateway = await fetchGatewayData();
                    setGatewayData(gateway);

                    const feeData = await fetchFeeData('ALLOTMENT', `PROCESSING_FEE${auction ? '' : ',SECURITY_DEPOSIT'}`, plotId);
                    setPaymentData(feeData?.feeMasterDetails);
                    setTotalPaidAmount(feeData?.totalPaidAmount);

                    const processingFee = feeData?.feeMasterDetails?.filter((ele: any) => ele.feeType === 'PROCESSING_FEE');
                    setDeductions({ TDSAmount: strToNum(processingFee[0]?.principalAmount) * 0.1, GST_TDSAmount: strToNum(processingFee[0]?.principalAmount) * 0.02 });
                }
            } catch (e: any) {
                console.log(e);
                let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
                setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
                setPaymentIsLoading(false);
            }
        })();
    }, [activeIndex, plotId]);

    useEffect(() => {
        (async () => {
            await setPlotData();
        })();
    }, [plotId]);

    useEffect(() => {
        if (values?.category?.code) {
            if (values?.category?.code === 'PROP_FIRM') {
                if (ownershipDetails?.length) {
                    setValues((prev: any) => ({ ...prev, nameOfAccountHolder: ownershipDetails[0]?.name }));
                } else {
                    setValues((prev: any) => ({ ...prev, nameOfAccountHolder: '' }));
                }
            } else {
                setValues((prev: any) => ({ ...prev, nameOfAccountHolder: values?.applicantName }));
            }
        }
    }, [values?.category?.code, ownershipDetails, values?.applicantName]);

    useEffect(() => {
        if (values.additionalDetails?.length && !steps.find((item: any) => item.titleCode === 'ADDITIONAL_DETAILS')) {
            setSteps([
                ...steps,
                {
                    titleCode: 'ADDITIONAL_DETAILS',
                    name: 'Aditional Details',
                    index: 6,
                    isActive: false
                }
            ]);
        }
    }, [values.additionalDetails?.length]);

    const fetchApplicationData = async (appNo: any, dropdown: any, applicantData: any) => {
        const nextActions = await getNextActions(applicationNumber);
        setHasValidAction(nextActions?.nextValidAction?.length > 0);
        setIsChecked([true, true, true]);
        setNextValidAction(nextActions);

        try {
            const { data } = await POST(endpoints.searchAllotment + `?applicationNos=${appNo}`, { RequestInfo: requestInfo() });
            if (data.estateApplications.length > 0) {
                let allotmentData = data.estateApplications?.[0];
                const res1 = await getEntityData(allotmentData?.enterpriseEntity, dropdown);
                const res2 = allotmentData?.enterpriseDetails && (await getEnterpriseData(allotmentData?.enterpriseDetails, dropdown));
                const applicantListRes = await POST(endpoints.applicantResponseSearch, { RequestInfo: requestInfo(), applicationNumbers: [appNo] });
                const applicantList = applicantListRes?.data?.applicantResponseDetailsList?.length
                    ? await Promise.all(
                          applicantListRes?.data?.applicantResponseDetailsList.map(async (item: any) => {
                              const res = item?.response ? await setApplicantResponse(item, dropdown) : undefined;
                              const document = item.supportingDocRefId ? await entityDocumentData(item.supportingDocRefId) : null;
                              return {
                                  ...item,
                                  fieldName: { code: item.code, name: item.description },
                                  remarks: item.requesterRemarks,
                                  supportingDoc: document,
                                  [item?.code]: res
                              };
                          })
                      )
                    : null;

                const plotInitData = getInitPlotData(allotmentData?.appliedPlotDetails);
                setSearchApplicationResponse(allotmentData.enterpriseEntity || {});
                setEstateResponse(allotmentData || {});
                allotmentData?.entityBankDetail && setBankDetails(true);
                setAllotmentDate(allotmentData?.auditDetails.createdTime);
                setAdvertisementNumber(allotmentData?.advertisement?.advNo || null);
                setFileStoreId(allotmentData?.signedConsolidatedDocRefId);
                setValues((prev: any) => ({
                    ...prev,
                    ...res1,
                    ...res2,
                    ...plotInitData,
                    isAdvertisement: !ipb && !auction ? true : false,
                    applicationId: allotmentData.uuid,
                    additionalDetails: applicantList,
                    isUpdatable: nextActions?.isUpdatable,
                    ...applicantData
                }));
                const newOwnership = await getFormatedOwnershipDetails(allotmentData?.enterpriseEntity?.owners, dropdown);
                setOwnershipDetails(newOwnership);
                setControllingOwnershipResponse(allotmentData?.enterpriseEntity?.owners);
                const newProposed = await getFormatedNICDetails(allotmentData?.enterpriseDetails?.nicEnterpriseMappings || [], dropdown);
                setNicDetails(newProposed);
                setPlotId(allotmentData?.appliedPlotDetails?.uuid);
            }
        } catch (e: any) {
            let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
            setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    console.log('formik', formik);

    const setApplicantData = async (dropdownData: any) => {
        try {
            const userId = JSON.parse(localStorage.getItem('user') || '{}')?.uuid;
            const { data } = await POST(endpoints.searchExistingUser + `?tenantId=${TENANT_ID}&userUuid=${userId}`, { RequestInfo: requestInfo() });
            if (data.enterpriseEntity.length > 0) {
                const res = await getEntityData(data.enterpriseEntity[0], dropdownData);
                setSearchApplicationResponse(data.enterpriseEntity[0]);
                data?.enterpriseEntity?.[0]?.entityBankDetail && setBankDetails(true);
                const newOwnership = await getFormatedOwnershipDetails(data?.enterpriseEntity[0].owners, dropdownData);
                setOwnershipDetails(newOwnership);
                setControllingOwnershipResponse(data?.enterpriseEntity[0].owners);
                return { ...res, specialProject: ipb ? true : false, isAdvertisement: !ipb && !auction ? true : false, isAuction: auction ? true : false };
            }
        } catch (e: any) {
            let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
            setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    const setPlotData = async () => {
        try {
            if (plotId) {
                const plotData = await autoPopulatePlotDetails(plotId);
                setValues({ ...values, ...plotData, enterpriseCategory: plotData?.enterpriseCategory });
                console.log('plotData', plotData);

                // const res1 = await POST(`/idc-estate-service/plot/_search?plotUuids=${plotId}`, { RequestInfo: requestInfo() });
                // const data = res1.data.plots[0];
                // const convertForm = (value: any) => {
                //     return { name: value || '', code: value || '' };
                // };
                // setValues({
                //     ...values,
                //     estateName: convertForm(data.estateDetails.estateName),
                //     phase: convertForm(data.phase),
                //     // plotNo: {convertForm(data.plotNo)},
                //     plotNo: { name: data.plotNo, code: data.plotNo },
                //     plotType: convertForm(data.plotType),
                //     plotRate: data.plotRate,
                //     plotArea: data.plotAreaSqm,
                //     enterpriseCategory: convertForm(data.plotType)
                // });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleCheckboxChange = (i: any) => {
        let checks = isChecked;
        checks[i] = !isChecked[i];
        setIsChecked([...checks]);
    };

    const handleModalClose = (type: string, final?: boolean, isUnauthorized?: boolean) => {
        setModalDetails({ show: false });
        if (type === 'success' && final) {
            navigate('/goa-idc/enterprisedashboard');
        } else if (isUnauthorized) {
            if (userType === 'ENTERPRISE') {
                navigate('/goa-idc/enterprisedashboard');
            } else if (userType === 'EXTERNAL_EMPLOYEE') {
                navigate('/goa-idc/architectdashboard');
            } else if (userType === 'EMPLOYEE') {
                navigate('/goa-idc/dashboard');
            }
        }
    };

    const showModal = () => {
        setAddButton(true);
    };

    const getSelectedDocuments = (documents: IdocumentTemplate[]) => {
        setFilesSelection(documents);
    };

    const handleOnAssignmentChange = (index: number, field: string, value: any) => {};

    const signDocument = async () => {
        let url =
            window.location.origin +
            `/goa-idc/estate/allotment?activeIndex=${activeIndex}&applicationNo=${applicationNo}&advertisementNumber=${advertisementNumber}&${
                formType === 'IPB' ? 'ipb=true' : formType === 'AUCTION' ? 'auction=true' : ''
            }`;
        url = btoa(url);

        if (values.esignOption === 'EKYC') {
            const eKYCInitiate =
                devUrl +
                endpoints.kycInitiate +
                `?fileStoreId=${eSignedDocumentData.filestoreId}&accessToken=${requestInfo().authToken}&userType=${requestInfo().userType}${
                    requestInfo().departmentCode ? `&departmentCode=${requestInfo().departmentCode}` : ''
                }&callBackUrl=${url}${values.esignUsername ? `&eSignUsername=${encode(values.esignUsername)}` : ''}`;

            window.open(eKYCInitiate, '_self');
        } else {
            navigate(`/goa-idc/emudra-esign?fileStoreId=${eSignedDocumentData.filestoreId}&callbackUrl=${url}`);
        }
    };

    const handleClickSignDocument = () => {
        if (activeIndex === 4 && !isChecked.every((e: boolean) => e)) {
            setModalDetails({ show: true, title: 'Error!', para: 'Please accept all the terms', img: cross, type: 'error', reUpload: 'OK' });
            return;
        }
        setEsignModal(true);
    };

    // const signDocument = async () => {
    // 	if (activeIndex === 4 && !isChecked.every((e: boolean) => e)) {
    // 		setModalDetails({ show: true, title: 'Error!', para: 'Please accept all the terms', img: cross, type: 'error', reUpload: 'OK' });
    // 		return;
    // 	}

    // 	try {
    // 		const userRequestInfo = requestInfo();
    // 		if (window.location.protocol !== 'http:') {
    // 			let url =
    // 				window.location.origin +
    // 				`/goa-idc/estate/allotment?activeIndex=${activeIndex}&applicationNo=${applicationNo}&advertisementNumber=${advertisementNumber}&${
    // 					formType === 'IPB' ? 'ipb=true' : formType === 'AUCTION' ? 'auction=true' : ''
    // 				}`;
    // 			url = btoa(url);
    // 			const esignUrl = `${devUrl}${endpoints.esignInitiate}?authType=1&callBackUrl=${url}&fileStoreId=${eSignedDocumentData?.filestoreId}&accessToken=${userRequestInfo.authToken}&userType=${
    // 				userRequestInfo.userType
    // 			}${userRequestInfo.departmentCode ? `&departmentCode=${userRequestInfo.departmentCode}` : ''}`;
    // 			await axios.get(esignUrl);

    // 			window.open(esignUrl, '_self');
    // 		} else {
    // 			let url =
    // 				window.location.origin +
    // 				`/goa-idc/estate/allotment?activeIndex=${activeIndex}&applicationNo=${applicationNo}&signedFileStoreId=${
    // 					eSignedDocumentData.filestoreId
    // 				}&advertisementNumber=${advertisementNumber}&${formType === 'IPB' ? 'ipb=true' : formType === 'AUCTION' ? 'auction=true' : ''}`;

    // 			window.open(url, '_self');
    // 		}
    // 	} catch (e) {
    // 		console.log('esign error', e);
    // 	}

    // 	// let url = window.location.origin + `/goa-idc/estate/allotment`;
    // 	// const formData = new FormData();
    // 	// formData.append('authType', '1');
    // 	// formData.append('callBackUrl', url);
    // 	// formData.append('fileStoreId', '3bee5050-f883-4d15-8fa8-47fcaaeab6a1');
    // 	// const headers = {
    // 	//     'Content-Type': 'application/json'
    // 	// };
    // 	// try {
    // 	// const response = await axios.post(
    // 	//     `https://20.0.129.210:9090/idc-doc-esign-services/v1/generateESignRequest?authType=1&callBackUrl=${url}&fileStoreId=3bee5050-f883-4d15-8fa8-47fcaaeab6a1`,
    // 	//     { RequestInfo: requestInfo() },
    // 	//     { headers }
    // 	// );
    // 	//     let payload = {
    // 	//         eSignRequest:
    // 	//             '<?xml version="1.0" encoding="UTF-8"?><Esign AuthMode="1" aspId="GIDC-900" ekycId="" ekycIdType="A" responseSigType="pkcs7" responseUrl="https://20.0.129.210:9090/idc-doc-esign-services/v1/handleResponse?newFilename=6c91377a-33cd-4410-81b9-ec1eeece9705&amp;originalFilename=Identity Proof&amp;callBackUrl=http://localhost:3000/goa-idc/estate/allotment" sc="Y" ts="2024-06-06T15:44:56" txn="1156067504" ver="2.1"><Docs><InputHash docInfo="My Document" hashAlgorithm="SHA256" id="1">88572ac7620784b6bafa5d195d254c5efe8db873619b230994ef0e85bd17aa1e</InputHash></Docs><Signature xmlns="http://www.w3.org/2000/09/xmldsig#"><SignedInfo><CanonicalizationMethod Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315"/><SignatureMethod Algorithm="http://www.w3.org/2000/09/xmldsig#rsa-sha1"/><Reference URI=""><Transforms><Transform Algorithm="http://www.w3.org/2000/09/xmldsig#enveloped-signature"/></Transforms><DigestMethod Algorithm="http://www.w3.org/2001/04/xmlenc#sha256"/><DigestValue>8p/XzXdwYxi0qSxLYTiYl2xyOD0zgdlrmx/QeeekuU8=</DigestValue></Reference></SignedInfo><SignatureValue>c5GqZt13j2BE7Y85IJ6h+tf7HWL2yzTmI1OCbAFgSnIWvv+wN7JS9s7ZW9MDtAt/uoVs4ao83ROx\ngU7FUJ8+ZGt/cdKGuzJCKws46wxmSQkG+qNG17KWypfjrrEE+srF4JIpeKWDbzfCXwzsx2Ge0ch8\nSYkl6Tse0JPlxO7+rjsVLkmXp9tbNaV7Hwsdba6Gc8zjFNp09nXmVAFtExZO0/cQej0XF2jb8DtT\nbqdfKNTiyp9ZSLOBonPRdrx44RhFUXmHxU7dcZAbfFpzy0fgm9JMLAvGqPxDVOKRA/aZJK5pBYAk\npqr1jSE4NS0x6QC0nqpx2ClcvX1/ivBvcWsuCA==</SignatureValue></Signature></Esign>',
    // 	//         aspTxnID: '1156067504',
    // 	//         contentType: 'application/xml'
    // 	//     };

    // 	//     const headers = {
    // 	//         Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
    // 	//         //     'Accept-Encoding': 'gzip, deflate, br, zstd',
    // 	//         //     'Accept-Language': 'en-US,en;q=0.9',
    // 	//         //     'Cache-Control': 'max-age=0',
    // 	//         //     Connection: 'keep-alive',
    // 	//         //     'Content-Length': 1975,
    // 	//         'Content-Type': 'application/x-www-form-urlencoded',
    // 	//         //     Host: 'es-staging.cdac.in',
    // 	//         Origin: 'https://localhost:9090',
    // 	//         Referer: 'https://localhost:9090/'
    // 	//         //     'Sec-Fetch-Dest': 'document',
    // 	//         //     'Sec-Fetch-Mode': 'navigate',
    // 	//         //     'Sec-Fetch-Site': 'cross-site',
    // 	//         //     'Sec-Fetch-User': '?1',
    // 	//         //     'Upgrade-Insecure-Requests': '1',
    // 	//         //     'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/126.0.0.0 Safari/537.36',
    // 	//         //     'sec-ch-ua': '"Not/A)Brand";v="8", "Chromium";v="126", "Google Chrome";v="126"',
    // 	//         //     'sec-ch-ua-mobile': '?0',
    // 	//         //     'sec-ch-ua-platform': '"Windows"'
    // 	//     };
    // 	//     const res = await axios.post('https://es-staging.cdac.in/esignlevel2/2.1/form/signdoc', payload, { headers });
    // 	//     console.log('res', res);
    // 	//     // console.log('Response:', response);
    // 	// } catch (error) {
    // 	//     console.error('Error uploading files', error);
    // 	// }
    // 	// console.log(`let's sign the document`);
    // };

    useEffect(() => {
        if (esignError && !signedFileStoreId && !queryParams?.['eg_pg_txnid']) {
            setModalDetails({ show: true, title: 'Error!', para: esignError || 'eSign failed, please try again', img: cross, type: 'error', reUpload: 'OK' });
        }

        (async () => {
            try {
                let payload = {
                    RequestInfo: requestInfo(),
                    applicationNumber: applicationNo || applicationNumber,
                    filestoreId: signedFileStoreId || undefined
                };

                if (signedFileStoreId) {
                    const { data } = await POST(endpoints.consolidatedDocESign, payload);
                    // setESignedDocumentData(data);
                    !data.isEsignRequired && setIsChecked([true, true, true]);
                    const consolidDocSearch = await POST(endpoints.consolidatedDocSearch, payload);
                    consolidDocSearch?.data.filestoreId && setESignedDocumentData(consolidDocSearch?.data);
                }
            } catch (e: any) {
                console.log(e);
                let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
                setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            }
        })();
    }, [signedFileStoreId]);

    useEffect(() => {
        const fetchESignStatus = async () => {
            try {
                let payload = {
                    RequestInfo: requestInfo(),
                    applicationNumber: applicationNo || applicationNumber,
                    filestoreId: signedFileStoreId || undefined
                };

                const { data } = await POST(endpoints.consolidatedDocSearch, payload);
                data.filestoreId && setESignedDocumentData(data);
                !data.isEsignRequired && setIsChecked([true, true, true]);
            } catch (e: any) {
                console.log(e);
                let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
                setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            }
        };
        if (activeIndex === 4 && (reVisit?.current ? reVisit.current : !signedFileStoreId) && !values.additionalDetails?.length) {
            fetchESignStatus();
        } else if (values.additionalDetails?.length) {
            setIsChecked([true, true, true]);
        }
    }, [activeIndex]);

    const renderDeclarationDetails = () => {
        const declarationList = [
            '(i) the information provided above and in the enclosed documents is true and correct to the best of my knowledge and belief and nothing material has been concealed herein.',
            '(ii) it has not taken any steps to take advantage of any bankruptcy or insolvency law or otherwise is not a party to any bankruptcy or liquidation proceeding.',
            '(iii) The provision allotment order or the lease deed,as the case may be,shall be liable to be cancelled if there is any misdeclaration or misrepresentation of the information submitted under or along with this application.'
        ];
        return (
            <>
                <Declaration
                    isChecked={isChecked}
                    declarationList={declarationList}
                    handleCheckboxChange={(e: any) => handleCheckboxChange(e)}
                    setDocuments={setDocuments}
                    signDocument={handleClickSignDocument}
                    eSignedDocumentData={eSignedDocumentData}
                    isDisabled={!hasValidAction}
                    fileStoreId={fileStoreId}
                ></Declaration>
            </>
        );
    };

    const getTransactionUpdate = async (params: any) => {
        try {
            if (params.plotId) {
                const paid: any = await paymentCheck('PROCESSING_FEE,SECURITY_DEPOSIT', params.plotId, params.applicationId || values?.applicationId);
                if (!paid.isPaid) {
                    const payload = { RequestInfo: requestInfo() };
                    const { data } = await POST2(endpoints.transactionUpdate, payload, { eg_pg_txnid: params.eg_pg_txnid });
                    if (data?.Transaction?.[0]?.txnStatus === 'SUCCESS') {
                        setTransactionDetails(data?.Transaction?.[0]);
                        if (data?.Transaction?.[0]?.txnId) {
                            try {
                                const resp = await POST(endpoints.paymentDetails + `?eg_pg_txnid=${data?.Transaction?.[0]?.txnId}`, payload);
                                if (resp.data.status === 'SUCCESSFUL') {
                                    setModalDetails({ show: true, title: 'Success!', para: 'Payment successful', img: check, type: 'success', reUpload: 'OK' });
                                    setIsPaid(true);
                                } else {
                                    setIsPaid(false);
                                }
                            } catch (e: any) {
                                console.log(e);
                                setIsPaid(false);
                                setPaymentIsLoading(false);
                            }
                        }
                    } else if (data?.Transaction?.[0]?.txnStatus === 'PENDING') {
                        setModalDetails({
                            show: true,
                            title: t('TRANSACTION_PENDING', 'Transaction Pending'),
                            para: t('PAYMENT_STATUS_PENDING_MSG', 'Your payment is under process; please revisit later for updates.'),
                            img: cross,
                            type: 'error',
                            reUpload: 'OK'
                        });
                        // window.location.reload();
                    } else {
                        setIsPaid(false);
                    }
                }
            }
            setIsLoading(false);
            setPaymentIsLoading(false);
        } catch (e: any) {
            console.log(e);
            setIsPaid(false);
            setIsLoading(false);
            setPaymentIsLoading(false);
            let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
            setModalDetails({ show: true, title: 'Transaction Failed', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    const callBackUrl = useMemo(
        () =>
            window.location.origin +
            `/goa-idc/estate/allotment?${
                formType === 'IPB' ? 'ipb=true&' : formType === 'AUCTION' ? 'auction=true&' : ''
            }plotId=${encode(plotId)}&activeIndex=${activeIndex}&advertisementNumber=${encode(advertisementNumber)}&applicationNo=${encode(applicationNo)}&applicationId=${encode(values.applicationId)}`,
        [formType, plotId, activeIndex, advertisementNumber, applicationNo, values?.applicationId]
    );

    const oneYearLaterDate = useMemo(() => {
        if (!allotmentDate) return null;
        const date = new Date(allotmentDate);
        date.setFullYear(date.getFullYear() + 1);
        return date;
    }, [allotmentDate]);

    const periodTo = useMemo(() => (oneYearLaterDate ? oneYearLaterDate.getTime() : null), [oneYearLaterDate]);

    const paymentPayload = useMemo(() => {
        return {
            RequestInfo: requestInfo(),
            applicationNumber: applicationNo || applicationNumber,
            plotId: plotId,
            totalPaidAmount: strToNum(finalPayableAmount),
            callbackUrl: callBackUrl,
            productInfo: 'Allotment Application Fees',
            gateway: selectedGateway,
            periodFrom: allotmentDate,
            periodTo: periodTo,
            payNowPaymentDetails: paymentData?.map((obj: any) => {
                let tds = obj.feeType === 'PROCESSING_FEE' && deductions?.TDSChecked ? deductions.TDSAmount.toFixed(2) : 0;
                let gstTds = obj.feeType === 'PROCESSING_FEE' && deductions?.GST_TDSChecked ? deductions.GST_TDSAmount.toFixed(2) : 0;
                return {
                    scheduledPaymentDetails: {
                        paymentType: obj.feeType,
                        principalAmount: obj.principalAmount,
                        cgstPrincipal: obj.cgstPrincipal,
                        sgstPrincipal: obj.sgstPrincipal,
                        totalDueAmount: ((+obj.principalAmount || 0) + (+obj.cgstPrincipal || 0) + (+obj.sgstPrincipal || 0)).toFixed(2),
                        paidAmount: ((+obj.principalAmount || 0) + (+obj.cgstPrincipal || 0) + (+obj.sgstPrincipal || 0) - tds - gstTds).toFixed(2),
                        tdsPrincipalAmount: tds,
                        gstTdsPrincipalAmount: gstTds
                    }
                };
            }),
            applicationId: values.applicationId
        };
    }, [applicationNo, applicationNumber, plotId, finalPayableAmount, callBackUrl, selectedGateway, allotmentDate, periodTo, paymentData, deductions, values.applicationId]);

    const onPay = async () => {
        setPaymentIsLoading(true);

        try {
            if (!totalPaidAmount) {
                setPaymentIsLoading(false);
                setModalDetails({ show: true, title: 'Error!', para: 'Total amount must be greater than zero', img: cross, type: 'error', reUpload: 'OK' });

                return;
            }
            if (!selectedGateway) {
                setPaymentIsLoading(false);
                setModalDetails({ show: true, title: 'Error!', para: 'Please select a payment gateway', img: cross, type: 'error', reUpload: 'OK' });

                return;
            }
            if (applicationNo && selectedGateway && totalPaidAmount > 0) {
                const { data } = await POST(endpoints.paymentGateway, paymentPayload);

                if (selectedGateway === 'HDFC' || selectedGateway === 'AXIS') {
                    const options: RazorpayOptions = getOptions(data.txnAmount, user, 'description', data?.additionalDetails.ORDER_ID, data.callbackUrl, KEY_ID[selectedGateway], setPaymentIsLoading);
                    console.log(options);
                    const rzp1: any = (window as any).Razorpay(options);
                    rzp1.open();
                    setPaymentIsLoading(false);
                } else if (selectedGateway === 'ICICI') {
                    console.log(data.additionalDetails);
                    navigate(
                        `/goa-idc/icici-payment?walletClientCode=${data.additionalDetails.walletClientCode}&walletRequestMessage=${data.additionalDetails[WALLET_REQUEST_MESSAGE_MAKE_PAYMENT_KEY]}`
                    );
                } else if (selectedGateway === 'YES_BANK') {
                    postToPaymentGateway(
                        data.additionalDetails.paymentInitiateRequest.request,
                        data.additionalDetails.paymentInitiateRequest.merchant_code,
                        data.additionalDetails.paymentInitiateApiUrl
                    );
                } else if (data && data.redirectUrl) {
                    window.open(data.redirectUrl, '_self');
                }
            }
        } catch (e: any) {
            console.log(e);
            let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
            setPaymentIsLoading(false);
            setModalDetails({ show: true, title: t('PAYMENT_FAILED', 'Payment Initiation Failed'), para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    const lastSubmit = (isSaveOnly?: boolean, status?: any, comment?: string) => {
        if (!isPaid) onPay();
        else onSubmit(isSaveOnly, status, comment);
    };

    const onSubmit = async (isSaveOnly?: boolean, status?: any, comment?: string) => {
        const isFinalSubmit = activeIndex === steps?.length ? true : false;
        const payload = allotmentPayload(values, advertisementNumber, plotId, formType, nicDetails, ownershipDetails, activeIndex, searchApplicationResponse, estateResponse, isFinalSubmit);
        let data;

        const currOwnership = ownershipDetails
            .filter((item: any) => !item.isDelete)
            .reduce((accumulator: number, subItem: any) => {
                return accumulator + subItem.ownershipInterest;
            }, 0);

        console.log(currOwnership);

        try {
            await ALLOTMENT_FORM_VALIDATION[`page${activeIndex}`].validate(values, { abortEarly: false, context: values });

            if (activeIndex === 1 && currOwnership != 100 && values?.category?.code !== 'LTD_COMPANY') {
                setModalDetails({ show: true, title: 'Error!', para: 'Your ownership interest does not add upto 100%', img: cross, type: 'error', reUpload: 'OK' });
                return;
            }

            if (activeIndex === 1 && !calculated) {
                setModalDetails({ show: true, title: 'Error!', para: 'Please calculate controlling ownership', img: cross, type: 'error', reUpload: 'OK' });

                return;
            }
            if (activeIndex === 3 && (!nicDetails || !nicDetails?.length)) {
                setModalDetails({ show: true, title: 'Error!', para: 'Please add atleast 1 proposed activity', img: cross, type: 'error', reUpload: 'OK' });

                return;
            }
            if (activeIndex === 4 && !isChecked.every((e: boolean) => e)) {
                setModalDetails({ show: true, title: 'Error!', para: 'Please accept all the terms', img: cross, type: 'error', reUpload: 'OK' });

                return;
            }

            if (activeIndex === 4 && eSignedDocumentData?.isEsignRequired) {
                setModalDetails({ show: true, title: 'E-Sign Pending', para: 'Please sign the document', img: cross, type: 'error', reUpload: 'OK' });
                return;
            }

            try {
                setIsLoading(true);
                if (!values.applicationId) {
                    data = await POST(endpoints.createAllotment, payload);
                } else {
                    data = await POST(endpoints.updateAllotment, payload);
                }
                !isSaveOnly && onChangeNextIndex();
                setIsLoading(false);
            } catch (e: any) {
                console.log(e);
                let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message;
                setIsLoading(false);
                setModalDetails({ show: true, title: `Application${applicationNo ? ' Number ' + applicationNo : ''} for Allotment Failed`, para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            }
            if (data) {
                setPlotId(plotId ? plotId : payload.appliedPlotId);
                setApplicationNo(data.data.estateApplications?.[0].applicationNo || '');
                setApplicationType(data.data.estateApplications?.[0].applicationType || '');
                setSearchApplicationResponse(data.data.estateApplications?.[0].enterpriseEntity || {});
                setEstateResponse(data.data.estateApplications?.[0] || {});
                data.data.estateApplications?.[0]?.entityBankDetail && setBankDetails(true);
                setAllotmentDate(data.data.estateApplications?.[0]?.auditDetails.createdTime);
                const entityDocs = await setEntityDocData(data.data.estateApplications?.[0]?.enterpriseEntity?.documents || []);
                const enterpriseDocs = await setEnterpriseDocData(data.data.estateApplications?.[0]?.enterpriseDetails?.documents || []);
                setValues({
                    ...values,
                    applicationId: data.data.estateApplications?.[0].uuid,
                    ...entityDocs,
                    ...enterpriseDocs
                });
                if (isFinalSubmit) {
                    setModalDetails({
                        show: true,
                        title: 'Success!',
                        para: `Application${applicationNo ? ' Number ' + applicationNo : ''} for Allotment submitted successfully`,
                        finalSubmit: true,
                        img: check,
                        type: 'success',
                        reUpload: 'OK'
                    });
                } else toast('Action successful', { position: toast.POSITION.TOP_RIGHT, className: 'foo-bar', type: 'success' });
            }
        } catch (validationError) {
            console.log(validationError);
            let errorField = getFirstErrorKey(errors);
            if (errorField) {
                const escapedErrorField = errorField.replace(/([[\].])/g, '\\$1');
                await setFieldTouched(errorField, true, true);
                let getErrorField: any = document.querySelector(`[name=${escapedErrorField}]`);
                getErrorField && getErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            setModalDetails({ show: true, title: 'Error!', para: t('ALL_REQUIRED_DETAILS', 'Please fill in all the required details!'), img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    const onChangeNextIndex = async () => {
        try {
            if (activeIndex < steps.length) {
                setActiveIndex(activeIndex + 1);
            }
            if (visitedIndex < activeIndex + 1) setVisitedIndex(activeIndex + 1);
            window.scrollTo(0, 0);
        } catch (e) {
            console.log(e);
            setModalDetails({ show: true, title: 'Error!', para: 'Please fill in all the required details!', img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    const onChangePrevIndex = () => {
        const stepperLength = steps.length;
        if (activeIndex <= stepperLength && activeIndex > 1) {
            setActiveIndex(activeIndex - 1);
            formik.setTouched({ back: true });
        }
        if (activeIndex <= 4 && signedFileStoreId) {
            resetUrl();
        }
    };

    const resetUrl = () => {
        let url = new URL(window.location.href);
        let searchParams = new URLSearchParams(url.search);
        reVisit.current = true;
        searchParams.set('reVisit', 'true');
        const newUrl = `${url.origin}${url.pathname}?${searchParams.toString()}`;
        window.history.replaceState({}, document.title, newUrl);
    };

    const handleStepClick = async (index: number) => {
        if (!hasValidAction || values.additionalDetails?.length) {
            setActiveIndex(index);
        } else {
            if (index <= activeIndex) {
                setActiveIndex(index);
                if (index < 4 && activeIndex >= 4 && signedFileStoreId) {
                    resetUrl();
                }
                window.scrollTo(0, 0);
            } else {
                setModalDetails({
                    show: true,
                    title: t('ERROR', 'Error!'),
                    para: t('PLEASE_SAVE_THE_APPLICATION', 'Please save the application before proceeding'),
                    img: cross,
                    type: 'error',
                    reUpload: 'OK'
                });
            }
        }
    };

    const handleScroll = () => {
        if (window.scrollY > 100) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const onChangeAction = (e: any, field: string) => {
        const { authorizedPersonFirstname, authorizedPersonLastName, pmobileNumber, alternateMobileNumber, authorizedEmailId, ...rest } = values;
        if (field === 'authorizedPersonFirstname') {
            setValues({
                ...rest,
                letter: null,
                authorizedPersonFirstname: e.target.value,
                authorizedPersonLastName: authorizedPersonLastName,
                pmobileNumber: pmobileNumber,
                alternateMobileNumber: alternateMobileNumber,
                authorizedEmailId: authorizedEmailId
            });
        } else if (field === 'authorizedPersonLastName') {
            setValues({
                ...rest,
                letter: null,
                authorizedPersonFirstname: authorizedPersonFirstname,
                authorizedPersonLastName: e.target.value,
                pmobileNumber: pmobileNumber,
                alternateMobileNumber: alternateMobileNumber,
                authorizedEmailId: authorizedEmailId
            });
        } else if (field === 'pmobileNumber') {
            setValues({
                ...rest,
                letter: null,
                authorizedPersonFirstname: authorizedPersonFirstname,
                authorizedPersonLastName: authorizedPersonLastName,
                pmobileNumber: e.target.value,
                alternateMobileNumber: alternateMobileNumber,
                authorizedEmailId: authorizedEmailId
            });
        } else if (field === 'alternateMobileNumber') {
            setValues({
                ...rest,
                letter: null,
                authorizedPersonFirstname: authorizedPersonFirstname,
                authorizedPersonLastName: authorizedPersonLastName,
                pmobileNumber: pmobileNumber,
                alternateMobileNumber: e.target.value,
                authorizedEmailId: authorizedEmailId
            });
        } else if (field === 'authorizedEmailId') {
            setValues({
                ...rest,
                letter: null,
                authorizedPersonFirstname: authorizedPersonFirstname,
                authorizedPersonLastName: authorizedPersonLastName,
                pmobileNumber: pmobileNumber,
                alternateMobileNumber: alternateMobileNumber,
                authorizedEmailId: e.target.value
            });
        }
    };

    const onCancel = () => {
        navigate(-1);
    };

    const resetPlot = () => {
        setValues({ ...values, estateName: '', phase: '', plotNo: '', plotType: '', plotRate: '', plotArea: '' });
    };

    console.log('dropdowndata', dropdownData);

    const status: any = progressBarDetails?.progressStatus?.find((item: any) => item.isCurrent === true);
    const applicationData = {
        applicationNo: applicationNo,
        status: progressBarDetails?.currentStatus,
        data: progressBarDetails?.auditTrails,
        // isRoleMD: isRoleMD,
        bpaData: '',
        pendingWith: status?.actor || '-'
    };

    useEffect(() => {
        const updatedDetails = handleUpdates(values, applicationDetailsII, APPLICANT_DETAILS_II, 'Address Details', 'Mailing/Correspondence address of the Entity');
        setApplicationDetailsII(updatedDetails);
    }, [values?.isPermanentPincodeDetailsPresent, values?.isPincodeDetailsPresent, values?.copyOnCheck]);

    const onRevert = async () => {
        if (!calculated) {
            setModalDetails({ show: true, title: 'Error!', para: 'Please calculate controlling ownership', img: cross, type: 'error', reUpload: 'OK' });
            return;
        }

        if (
            values?.additionalDetails?.find((val: any) => val?.code === 'APPLICANT_OWNER') &&
            Object.keys(values?.additionalDetails?.find((val: any) => val?.code === 'APPLICANT_OWNER'))?.length &&
            !calculated
        ) {
            setModalDetails({ show: true, title: 'Error!', para: 'Please calculate controlling ownership', img: cross, type: 'error', reUpload: 'OK' });
            return;
        }

        if (
            values?.additionalDetails?.find((val: any) => val?.code === 'ENTERPRISE_NIC_PROPOSED_ACTIVITY') &&
            Object.keys(values?.additionalDetails?.find((val: any) => val?.code === 'ENTERPRISE_NIC_PROPOSED_ACTIVITY'))?.length &&
            nicDetails?.length === 0
        ) {
            setModalDetails({ show: true, title: 'Error!', para: 'Add at least 1 NIC details', img: cross, type: 'error', reUpload: 'OK' });
            return;
        }

        try {
            await APPLICANT_RES_LIST_VALIDATION_II.validate(values, { abortEarly: false, context: values });
            try {
                setIsLoading(true);
                const payload = revertApplicantSubmitPayload(applicationNo, nextValidAction, estateResponse, values, { ownershipDetails: ownershipDetails, nicDetails: nicDetails });

                const { data } = await POST(endpoints.applicantResponseSave, payload);
                setModalDetails({ show: true, title: 'Success!', para: 'The response has been successfully submitted', img: check, type: 'success', reUpload: 'OK', finalSubmit: 'true' });
                setIsLoading(false);
            } catch (e: any) {
                setIsLoading(false);
                console.log(e);
                setModalDetails({ show: true, title: 'Error!', para: e?.response?.data?.errorMessage || e?.response?.data?.Errors[0]?.message, img: cross, type: 'error', reUpload: 'OK' });
            }
        } catch (e: any) {
            setIsLoading(false);
            console.log(e);
            setModalDetails({ show: true, title: 'Error!', para: t('ALL_REQUIRED_DETAILS', 'Please fill in all the required details!'), img: cross, type: 'error', reUpload: 'OK' });
            return;
        }
    };

    console.log('activeIndex', activeIndex);

    return (
        <>
            <HeaderComponent />
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <StatusAlertPopup
                        title={modalDetails.title}
                        para={modalDetails.para}
                        img={modalDetails.img}
                        show={modalDetails.show}
                        handleClose={() => handleModalClose(modalDetails.type, modalDetails?.finalSubmit, modalDetails?.isUnauthorized)}
                        type={modalDetails.type}
                        reUpload={modalDetails.reUpload}
                        handleSubmit={() => handleModalClose(modalDetails.type, modalDetails?.finalSubmit, modalDetails?.isUnauthorized)}
                    />
                    <div className='employee-creation-container bg-light m-auto px-5 py-4 row'>
                        <GenericHeader
                            text={t('APPLICATION_ALLOTMENT_FORM', `Application for Allotment via ${ipb ? 'IPB' : auction ? 'Auction' : 'Advertisement'}`)}
                            bottomSubText={applicationNo ? `Type : ${applicationType}, No : ${applicationNo}` : ``}
                            additionalClass='sub-text-style'
                        />
                        <div className='col-3 stickyCard-section'>
                            <div className='stickyCard'>
                                <GenericHeader
                                    text={t('APPLICATION_ALLOTMENT_FORM', `Application for Allotment via ${ipb ? 'IPB' : auction ? 'Auction' : 'Advertisement'}`)}
                                    sideHeader={true}
                                    additionalClass='sub-text-style'
                                    bottomSubText={applicationNo ? `Type : ${applicationType}, No : ${applicationNo}` : ``}
                                />

                                <Card className='card_border'>
                                    <Card.Body>
                                        <Card.Text className=' d-flex flex-column row-gap-3  '>
                                            <SideCard steps={steps} activeIndex={activeIndex} visitedIndex={visitedIndex} handleStepClick={handleStepClick} indexType={'alphabets'} />
                                        </Card.Text>
                                    </Card.Body>
                                </Card>

                                {/* {templateLinks?.length > 0 && (
                            // <Card className='card_border'>
                            //     <Card.Body>
                            //         <Card.Title>Templates</Card.Title>
                            //         {templateLinks.map((link: any) => (
                            //             <div>
                            //                 <div
                            //                     onClick={() => {
                            //                         handleOnDownloadTemplate(link.documentReferenceId);
                            //                     }}
                            //                     style={{ cursor: 'pointer', color: '#619050', textDecoration: 'underline' }}
                            //                 >
                            //                     {link.documentName}
                            //                 </div>
                            //             </div>
                            //         ))}
                            //     </Card.Body>
                            // </Card>
                            )} */}
                                <TemplateCard category={`ENTITY_REGISTRATION, ENTERPRISE_DETAILS`} />
                            </div>
                        </div>

                        <div className='col-9 form-section'>
                            {!!applicationNumber && applicationData.status !== 'Draft' && !hasValidAction && (
                                <Card className='card_border my-2'>
                                    <Card.Body>
                                        <PaymentSubmissionStatus data={applicationData} progressBarDetails={progressBarDetails} children={<ProgressBar progressBarDetails={progressBarDetails} />} />
                                    </Card.Body>
                                </Card>
                            )}
                            <FormikProvider value={formik}>
                                <Form>
                                    {activeIndex === 1 && (
                                        <Card className='card_border'>
                                            <ApplicantDetails
                                                dropdownOptions={dropdownData}
                                                setOwnershipDetails={setOwnershipDetails}
                                                controllingOwnershipResponse={controllingOwnershipResponse}
                                                setControllingOwnershipResponse={setControllingOwnershipResponse}
                                                ownershipDetails={ownershipDetails}
                                                setCalculated={setCalculated}
                                                isDisabled={!isApplicantRole}
                                                showOwnershipModal={showOwnershipModal}
                                                setShowOwnershipModal={setShowOwnershipModal}
                                                applicantDetails1={applicantDetailsI}
                                                applicantDetails2={applicationDetailsII}
                                                promoterDetails={PROMOTER_DETAILS}
                                                ownershipDisable={!isApplicantRole}
                                                onChangeAction={onChangeAction}
                                                scrollNotRequired={true}
                                                skipFullOwnershipPercent={values?.category?.code === 'LTD_COMPANY'}
                                                bankSectionDisable={bankDetails} //{isApplicantRole ? !user?.roles?.find((val: any) => val?.code === 'SUB_LESSEE' || val?.code === 'SUB_LESSEE_APPLICANT') : true}
                                            ></ApplicantDetails>
                                        </Card>
                                    )}
                                    {activeIndex === 2 && (
                                        <PlotDetails
                                            dropdownData={dropdownDataPlot}
                                            setDropdownData={setDropdownDataPlot}
                                            isFieldDisable={formType === 'IDC' || !hasValidAction}
                                            auction={auction}
                                            ipb={ipb}
                                        ></PlotDetails>
                                    )}
                                    {activeIndex === 3 && (
                                        <Card className='card_border'>
                                            <EnterpriseDetails
                                                enterpriseDetails={ENTERPRISE_DETAILS}
                                                enterpriseProjectDetails={PROJECT_DETAILS}
                                                declarationDetails={DECLARATION_DETAILS}
                                                dropdownOptions={dropdownData}
                                                handleOnAssignmentChange={handleOnAssignmentChange}
                                                nicDetails={nicDetails}
                                                setNicDetails={setNicDetails}
                                                showPopUp={showPopUp}
                                                setShowPopUp={setShowPopUp}
                                                isDisabled={!hasValidAction || !values.isUpdatable}
                                            ></EnterpriseDetails>
                                        </Card>
                                    )}
                                    {activeIndex === 4 && renderDeclarationDetails()}
                                    {activeIndex === 5 && (
                                        <>
                                            {paymentIsLoading && <Loading />}
                                            <PaymentDetails
                                                paymentData={paymentData}
                                                selectedGateway={selectedGateway}
                                                setSelectedGateway={setSelectedGateway}
                                                isPaid={isPaid}
                                                gatewayData={gatewayData}
                                                transactionDetails={transactionDetails}
                                                content={
                                                    <TDSSection
                                                        deductions={deductions}
                                                        setDeductions={setDeductions}
                                                        totalAmount={totalPaidAmount}
                                                        finalPayableAmount={finalPayableAmount}
                                                        setFinalPayableAmount={setFinalPayableAmount}
                                                        transactionDetails={transactionDetails}
                                                    />
                                                }
                                                paymentPayload={paymentPayload}
                                                setIsLoading={setPaymentIsLoading}
                                                setModalDetails={setModalDetails}
                                            ></PaymentDetails>
                                        </>
                                    )}
                                    {activeIndex === 6 && (
                                        <AdditionalDetails
                                            data={values.additionalDetails}
                                            nicDetails={nicDetails}
                                            setNicDetails={setNicDetails}
                                            showPopUp={showPopUp}
                                            setShowPopUp={setShowPopUp}
                                            dropdownData={dropdownData}
                                            setOwnershipDetails={setOwnershipDetails}
                                            controllingOwnershipResponse={controllingOwnershipResponse}
                                            setControllingOwnershipResponse={setControllingOwnershipResponse}
                                            ownershipDetails={ownershipDetails}
                                            setCalculated={setCalculated}
                                            showOwnershipModal={showOwnershipModal}
                                            setShowOwnershipModal={setShowOwnershipModal}
                                            onChangeAction={onChangeAction}
                                            scrollNotRequired={true}
                                            skipFullOwnershipPercent={values?.category?.code === 'LTD_COMPANY'}
                                        />
                                    )}
                                </Form>
                                <GenericPopupModal
                                    title={t('SIGN_THE_DOCUMENT', 'Sign the document')}
                                    primaryBtnTitle={t('CONFIRM', 'Confirm')}
                                    secondaryBtnTitle={t('CLOSE', 'Close')}
                                    isSecondaryBtn={true}
                                    secondaryAction={() => {
                                        setEsignModal(false);
                                        setValues((prevVal: any) => ({ ...prevVal, esignOption: 'DSC', esignUsername: '' }));
                                    }}
                                    primaryAction={signDocument}
                                    isVisible={esignModal}
                                    children={<EsignModal />}
                                    isPrimaryDisabled={values?.esignOption === 'EKYC' && !values?.esignUsername}
                                />
                            </FormikProvider>
                        </div>
                    </div>
                    <ScrollToTop />
                    <footer className='footer fixed-bottom footerBtnPatch'>
                        <div className='d-flex'>
                            <div className='d-flex justify-content-start  container me-3' style={{ padding: 15 }}>
                                {activeIndex !== 1 && <GenericButtons text={t('PREVIOUS', 'Previous')} handleClick={onChangePrevIndex} />}
                            </div>
                            <div className='d-flex justify-content-end  container me-3' style={{ padding: 15 }}>
                                {hasValidAction && !values.additionalDetails?.length ? (
                                    <>
                                        {activeIndex === 2 && (ipb || auction) && <GenericButtons text={t('RESET', 'Reset')} handleClick={() => resetPlot()} ClassName='me-3' />}
                                        {activeIndex !== steps.length && (
                                            <GenericButtons
                                                text={t('SAVE', 'Save')}
                                                handleClick={() => {
                                                    onSubmit(true);
                                                }}
                                                ClassName='me-3'
                                            />
                                        )}
                                        <GenericButtons
                                            text={activeIndex !== steps.length ? `Save & Next` : isPaid === null ? '' : !isPaid ? (paymentTried ? `Retry Payment` : `Pay Now`) : t('SUBMIT', 'Submit')}
                                            variant='primary'
                                            handleClick={() => (activeIndex !== steps.length ? onSubmit() : lastSubmit && lastSubmit())}
                                        />
                                    </>
                                ) : (
                                    <>
                                        {activeIndex === steps.length ? (
                                            values.additionalDetails?.length && hasValidAction ? (
                                                <GenericButtons text={t('SUBMIT', 'Submit')} variant='primary' handleClick={onRevert} />
                                            ) : (
                                                <GenericButtons text={t('CLOSE', 'Close')} variant='primary' handleClick={onCancel} />
                                            )
                                        ) : (
                                            <>
                                                <GenericButtons text={t('NEXT', 'Next')} variant='primary' handleClick={onChangeNextIndex} />
                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </footer>
                </>
            )}
        </>
    );
}
